export function getDateTimeLabel(date: string | number | Date): string {
  return new Intl.DateTimeFormat(navigator.language, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(date));
}

const relativeF = new Intl.RelativeTimeFormat(navigator.language, {
  numeric: 'auto',
  style: 'short',
});

export function getRelativeTime(date: string): string {
  const diffInMs = new Date(date).getTime() - Date.now();

  const seconds = Math.floor(diffInMs / 1000);
  if (Math.abs(seconds) < 60) {
    return relativeF.format(seconds, 'second');
  }

  const minutes = Math.floor(seconds / 60);
  if (Math.abs(minutes) < 60) {
    return relativeF.format(minutes, 'minute');
  }

  const hours = Math.floor(minutes / 60);
  if (Math.abs(hours) < 24) {
    return relativeF.format(hours, 'hour');
  }

  const days = Math.floor(hours / 24);
  if (Math.abs(hours) < 365) {
    return relativeF.format(days, 'day');
  }

  const years = Math.floor(days / 30);
  return relativeF.format(years, 'months');
}
